import React from "react";
import { View } from "react-native";
import { z as zod } from "zod";
import { toFormikValidationSchema } from "zod-formik-adapter";
import { FormContext, Formik, } from "@clearabee/ui-library-base";
import { Field } from "./Field/Field";
export const Form = ({ children, styles: userStyles, ...formikProps }) => {
    const { validationSchema: formikValidationSchema } = formikProps;
    const isZodSchema = formikValidationSchema instanceof zod.Schema;
    return (React.createElement(Formik.Formik, { ...{
            ...formikProps,
            validationSchema: formikValidationSchema && isZodSchema
                ? toFormikValidationSchema(formikValidationSchema)
                : formikValidationSchema,
        } }, (formik) => {
        const fields = typeof children === "function"
            ? children({ ...formik, Field })
            : children;
        return (React.createElement(FormContext.Provider, { value: { ...formik, validationSchema: formikValidationSchema } },
            React.createElement(View, { testID: "fields-wrapper", style: userStyles }, fields)));
    }));
};
export { useFormContext } from "@clearabee/ui-library-base";
//# sourceMappingURL=Form.js.map